import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './PasswordRequirements.styled';

/**
 * Container for password requirements that will show as passed/failed based on password input string.
 * A green check mark will appear next to each requirement that passes.
 */
const PasswordRequirements = ({
  validLength,
  hasCase,
  hasNumber,
  hasSpecial
}) => (
  <Styled.PasswordRequirements>
    Password must contain:
    <Styled.PasswordRequirementsList>
      <Styled.ListItem valid={validLength}>
        {validLength ? <Styled.CheckIcon name="check" /> : '•'}
        <Styled.Requirement>At least 8 characters</Styled.Requirement>
      </Styled.ListItem>
      <Styled.ListItem valid={hasCase}>
        {hasCase ? <Styled.CheckIcon name="check" /> : '•'}
        <Styled.Requirement>Lowercase and uppercase letters</Styled.Requirement>
      </Styled.ListItem>
      <Styled.ListItem valid={hasNumber}>
        {hasNumber ? <Styled.CheckIcon name="check" /> : '•'}
        <Styled.Requirement>A number</Styled.Requirement>
      </Styled.ListItem>
      <Styled.ListItem valid={hasSpecial}>
        {hasSpecial ? <Styled.CheckIcon name="check" /> : '•'}
        <Styled.Requirement>A special character</Styled.Requirement>
      </Styled.ListItem>
    </Styled.PasswordRequirementsList>
  </Styled.PasswordRequirements>
);

PasswordRequirements.propTypes = {
  /**
   * A valid password must be at lease 5 characters in length
   */
  validLength: PropTypes.bool,
  /**
   * A valid password must contain an upper case letter
   */
  hasCase: PropTypes.bool,
  /**
   * A valid password must contain a number
   */
  hasNumber: PropTypes.bool,
  /**
   * A valid password must contain a special character
   */
  hasSpecial: PropTypes.bool
};

PasswordRequirements.defaultProps = {
  validLength: false,
  hasCase: false,
  hasNumber: false,
  hasSpecial: false
};

export default PasswordRequirements;
